
import find from 'lodash/find';
import union from 'lodash/union';
import filter from 'lodash/filter';

import MaterialTypes from '../../constants/json/radiobuttons/materialTypes.json';
import individualTest from '../../constants/json/checkboxes/individualTestPackages.json';

let brandArray = {
  brandId: false,
  productId: false,
  isMaterial: '',
  isMaterialNumber: '',
  isError: true,
  isRetest:false,
  originalTRF:'',
  materialType:[],
  testPackagesValidationArry: [],
};

let testInfoArray = {
  season: false,
  variants: false,
  testingType: 'PR',
  isMaterialTypeVariant: true,
  isMaterialType: false,
  materialType: '',
  materialNames: [],
  multiVariantMaterial: false,
  multiVariants: [],
  isMaterialVarient: false,
  allVarientPresent: false,
  pColor: '',
  sampleDescription: '',
  repellent: false,
  foodOrMouth: false,
  mates: false,
  isTestingType: false,
  testPackages: [],
  testPackage: '',
  isTestPackageVariant: false,
  testPackageVariants: [],
  initialProductId: 0,
  currentProductId: 0,
  isError: true,
  recycle:false,
  listRecycle:'',
  describeRecycle:'',
  //subRecycledContent: 'No',
  //recycledContent: 'No',
  currentProductType: 100,
  InitialProductType: 100,
  testPackagesValidationArry: [],
  testPackagesJewelryValidationArry: [],
  testPackagesElectronicValidationArry: [],
  testPackagesPackagingValidationArry: [],
  jewelryMaterialTypeValidation:' ',
  subVariants: 0,
  skinContact: false,
  electCategory: '',
  productIdEdit: 1,
  sampleType:'',
  ageGroup:'',
  sampleColor:''
};

const ensureArray = value => (Array.isArray(value) ? [...value] : []);

const resetMaterialTypeArray = (payload) => {
  testInfoArray.materialType = [...payload];
  testInfoArray.materialNames = payload.filter(v => v !== null);
  testInfoArray.isMaterialVarient = false;
  testInfoArray.allVarientPresent = false;
};

const isYogaMateSolventRequired = currentTestInfoArray => {
  const productIds = [
    currentTestInfoArray.currentProductType,
    currentTestInfoArray.InitialProductType,
    currentTestInfoArray.currentProductId,
    currentTestInfoArray.productIdEdit
  ];

  return productIds.includes(202) && currentTestInfoArray.mates === true;
};

const syncYogaMateSolventValidation = currentTestInfoArray => {
  currentTestInfoArray.testPackagesValidationArry = ensureArray(currentTestInfoArray.testPackagesValidationArry);
  currentTestInfoArray.testPackages = ensureArray(currentTestInfoArray.testPackages);
  currentTestInfoArray.testPackagesForEdit = ensureArray(currentTestInfoArray.testPackagesForEdit);

  if (!isYogaMateSolventRequired(currentTestInfoArray)) {
    currentTestInfoArray.testPackage = currentTestInfoArray.testPackages;
    return currentTestInfoArray;
  }

  if (!currentTestInfoArray.testPackagesValidationArry.includes(599)) {
    const emptyIndex = currentTestInfoArray.testPackagesValidationArry.findIndex(value => value === null || value === undefined);
    if (emptyIndex === -1) {
      currentTestInfoArray.testPackagesValidationArry.push(599);
    } else {
      currentTestInfoArray.testPackagesValidationArry[emptyIndex] = 599;
    }
  }

  if (!currentTestInfoArray.testPackages.includes(599)) {
    currentTestInfoArray.testPackages.push(599);
  }

  if (!currentTestInfoArray.testPackagesForEdit.includes(599)) {
    currentTestInfoArray.testPackagesForEdit.push(599);
  }

  currentTestInfoArray.testPackage = currentTestInfoArray.testPackages;
  return currentTestInfoArray;
};


let labSelectionArray = {
  islabSelect: false,
  locationPayload: '',
  labLocation: false,
  isServiceRequest: false,
  isError: true
};


export const brandInfoValidations = (field, payload, mode) => {
  if (mode === 'Create') {
    if (field.indexOf('brandId') !== -1) {
      brandArray.brandId = true;
    }
    if (field.indexOf('productId') !== -1) {
      brandArray.productId = true;
    }
    if (field.indexOf('isLicensee') !== -1) {
      brandArray.isLicensee = payload;
    }
    if (field.indexOf('licensee') !== -1) {
      brandArray.licensee = payload;
    }
    if (field.indexOf('isRetest') !== -1) {
      brandArray.isRetest = payload;
    }
    if (field.indexOf('originalTRF') !== -1) {
      brandArray.originalTRF = payload;
    }
    if (field.indexOf('materialName') !== -1) {
      brandArray.isMaterial = payload;
    }
    if (field.indexOf('materialNumber') !== -1) {
      brandArray.isMaterialNumber = payload;
    }
  }
  else if (mode === 'Edit') {
    brandArray.productId = payload.productId ? true : false;
    brandArray.brandId = payload.brandId ? true : false;
    brandArray.isMaterial = payload.materialName ? payload : '';
    brandArray.isMaterialNumber = payload.materialNumber ? payload : '';
  }
  if (field.indexOf('materialType') !== -1) {
    brandArray.materialType = payload;
  }
  return brandArray;
};
export const brandInfoValidationsForEdit = (field, payload, mode) => {
  brandArray.productId = payload.productId ? true : false;
  brandArray.brandId = payload.brandId ? true : false;
  brandArray.isLicensee = payload.licensee ? "Yes" : "No";
  brandArray.licensee = payload.licensee ? payload.licensee : null;
  brandArray.isRetest = (payload.isRetest && payload === 'Yes') ? true : false;
  brandArray.originalTRF = payload.originalTRF ? payload.originalTRF : null; //new added
  brandArray.isMaterial = payload.materialName ? payload : '';
  brandArray.isMaterialNumber = payload.materialNumber ? payload : '';
  return brandArray;
};
export const testingInformationArry = (field, payload, oldProductType, newProductType, getProductTypeChangeStatus) => {
  if (field.indexOf('season') !== -1) {
    testInfoArray.season = true;
  }
  if (field.indexOf('testingType') !== -1) {
    testInfoArray.testingType = payload;
  }
  if (field.indexOf('sampleDescription') !== -1) {
    testInfoArray.sampleDescription = payload;
  }
  if (field.indexOf('pigmentColor') !== -1) {
    testInfoArray.pColor = payload;
  }
  if (field.indexOf('materialName') !== -1) {
    testInfoArray.isMaterial = payload;
  }
  if (field.indexOf('repellent') !== -1) {
    testInfoArray.repellent = payload === 'Yes';
  }
  // ADD: handle food/mouth toggle in Create mode
  if (field.indexOf('foodOrMouth') !== -1) {
    testInfoArray.foodOrMouth = payload === 'Yes';
  }
  if (field.indexOf('mates') !== -1) {
    testInfoArray.mates = payload === 'Yes';
  }
  if (field.indexOf('skinContact') !== -1) {
    testInfoArray.skinContact = payload === 'Yes';
  }
  if (field.indexOf('electCategory') !== -1) {
    testInfoArray.electCategory = payload;
  }
  if(field.indexOf('materialNames') !== -1){
    testInfoArray.materialNames = payload;
  }
  if (field.indexOf('jeweleryMaterialType') !== -1) {
    testInfoArray.jeweleryMaterialType = payload;
    testInfoArray.jewelryMaterialTypeValidation = payload
  }
  if (field.indexOf('sampleType') !== -1) {
    testInfoArray.sampleType = true;
  }
  if (field.indexOf('ageGroup') !== -1) {
    testInfoArray.ageGroup = true;
  }
  if (field.indexOf('sampleColor') !== -1) {
    testInfoArray.sampleColor = true;
  }
  if (field.indexOf('recycle') !== -1) {
    testInfoArray.recycle = payload === 'Yes';
  }
  if (field.indexOf('listRecycle') !== -1) {
    testInfoArray.listRecycle = payload;
  }
  if (field.indexOf('describeRecycle') !== -1) {
    testInfoArray.describeRecycle = payload;
  }

  /* if (field.indexOf('recycledContent') !== -1) {
    if (payload === 'Yes') {
      testInfoArray.recycledContent = 'Yes';
    } else {
      testInfoArray.recycledContent = 'No';
    }
  }
  if (field.indexOf('subRecycledContent') !== -1) {
    if (payload === 'Post Consumer' || payload === 'Post-Industrial') {
      testInfoArray.subRecycledContent = 'Yes';
    } else {
      testInfoArray.subRecycledContent = 'No';
    }
  } */
  if (oldProductType !== newProductType && getProductTypeChangeStatus === true &&
    field !== 'testPackages' &&
  !field.includes('testPackages') &&
  field !== 'repellent' &&
  field !== 'foodOrMouth' &&
  field !== 'recycledContent' &&
  field !== 'subRecycledContent' &&
  field !== 'sampleType' &&
  field !== 'ageGroup' &&
  field !== 'sampleColor' &&
  field !== 'sampleDescription' &&
  field !== 'season' &&
  field !== 'testingType' &&
  field !== 'pigmentColor' &&
  field !== 'materialName' &&
  field !== 'skinContact' &&
  field !== 'electCategory' &&
  field !== 'materialNames' &&
  field !== 'jeweleryMaterialType' &&
  field !== 'recycle' &&
  field !== 'listRecycle' &&
  field !== 'describeRecycle' &&
  field !== 'eyeWear' &&
  field !== 'mates' &&
  !field.startsWith('materialType') &&
  !field.startsWith('variants') &&
  !field.startsWith('tp-variants') &&
  field !== 'supplierName' &&
  field !== 'supLocName' &&
  field !== 'testmaterialName' &&
  field !== 'testmaterialNumber' &&
  field !== 'refId' &&
  field !== 'colorCode' &&
  field !== 'colorName' &&
  field !== 'colorway' &&
  field !== 'Year' &&
  field !== 'inkSystemName' &&
  field !== 'baseName' &&
  field !== 'additive1Name' &&
  field !== 'additive2Name' &&
  field !== 'additive3Name') {
    testInfoArray.testPackages = []
    testInfoArray.testPackageVariants = []
    testInfoArray.variants = false //SubVaraints initially false for materials
    testInfoArray.tp_variants = false //Test Package Varaints initially false
    testInfoArray.testPackage = ''
    testInfoArray.isTestPackageVariant = false;
    testInfoArray.testPackagesElectronicValidationArry = []
    testInfoArray.testPackagesJewelryValidationArry = []
    testInfoArray.testPackagesPackagingValidationArry = []
    testInfoArray.testPackagesValidationArry = []
    const materialNamesArryNull = testInfoArray.materialNames && testInfoArray.materialNames.filter((result) => {
    return result === null 
    })
    const materialTypeArryNull = testInfoArray.materialType && testInfoArray.materialType.filter((result) => {
    return result === null 
    }) 
    testInfoArray.materialNames=materialNamesArryNull
    testInfoArray.materialType=materialTypeArryNull 
    testInfoArray.materialName = ''
    testInfoArray.pigmentColor = ''
    delete testInfoArray[`tp-variants${testInfoArray.testPackage}`]
    delete testInfoArray.variants
    delete testInfoArray.tp_variants

    // Delete all variant fields for materials that have variants
    MaterialTypes.forEach(material => {
      if (material.variant) {
        delete testInfoArray[`variants${material.id}`];
      }
    });
    // Delete all variant fields for test packages that have variants
    individualTest[0].common.forEach(testPackages => {
      if (testPackages.variant && testPackages.isTestAvailable === true) {
        delete testInfoArray[`tp-variants${testPackages.id}`];
      }
    });

    // Delete all variant fields for electronic that have variants
    individualTest[0].electronic.forEach(testPackages => {
      if (testPackages.variant && testPackages.isTestAvailable === true) {
        delete testInfoArray[`tp-variants${testPackages.id}`];
      }
    });

    // Delete all variant fields for jewelrythat have variants
    individualTest[0].jewelry.forEach(testPackages => {
      if (testPackages.variant && testPackages.isTestAvailable === true) {
        delete testInfoArray[`tp-variants${testPackages.id}`];
      }
    });

    // Delete all variant fields for packaging have variants
    individualTest[0].packaging.forEach(testPackages => {
      if (testPackages.variant && testPackages.isTestAvailable === true) {
        delete testInfoArray[`tp-variants${testPackages.id}`];
      }
    });
  }
  
  return testInfoArray
}

export const individualPackageNotEqualProductTypeArry = (testInfoArray, field, payload, oldProductType, newProductType) => {
  if (field.match(/\d/g) === null) {
    testInfoArray.testPackagesValidationArry = []
    testInfoArray.testPackagesPackagingValidationArry = []
    testInfoArray.testPackagesElectronicValidationArry = []
    testInfoArray.testPackagesJewelryValidationArry = []
    testInfoArray.testPackageVariants= []
}
    if (field.indexOf('testPackagesJewelry') !== -1) {
      if (field.match(/\d/g) && field.match(/\d/g).length === 1) {
        testInfoArray.testPackagesJewelryValidationArry[field.match(/\d/g)] = payload;
      } else {
        testInfoArray.testPackagesJewelryValidationArry[field.match(/\d\d/g)] = payload;
      }
    }
    else if (field.indexOf('testPackagesElectronic') !== -1) {
      if (field.match(/\d/g) && field.match(/\d/g).length === 1) {
        testInfoArray.testPackagesElectronicValidationArry[field.match(/\d/g)] = payload;
      } else {
        testInfoArray.testPackagesElectronicValidationArry[field.match(/\d\d/g)] = payload;
      }
    }
    else if (field.indexOf('testPackagesPackaging') !== -1) {
      if (field.match(/\d/g) && field.match(/\d/g).length === 1) {
        testInfoArray.testPackagesPackagingValidationArry[field.match(/\d/g)] = payload;
      } else {
        testInfoArray.testPackagesPackagingValidationArry[field.match(/\d\d/g)] = payload;
      }
    }
    else if (field.indexOf('testPackages') !== -1) {
      if (field.match(/\d/g) && field.match(/\d/g).length === 1) {
        testInfoArray.testPackagesValidationArry[field.match(/\d/g)] = payload;
      } else {
        testInfoArray.testPackagesValidationArry[field.match(/\d\d/g)] = payload;
      }
    }
  
  const selectedTestPackagesArry = testInfoArray.testPackagesValidationArry
  const selectedTestPackagesJeweleryArry = testInfoArray.testPackagesJewelryValidationArry
  const selectedTestPackagesPackagingArry = testInfoArray.testPackagesPackagingValidationArry
  const selectedTestPackagesElectronicArry = testInfoArray.testPackagesElectronicValidationArry
  const finalTestPackagesArry = union(selectedTestPackagesArry, selectedTestPackagesElectronicArry, selectedTestPackagesJeweleryArry, selectedTestPackagesPackagingArry)
  const testPackagesRemoveNull = finalTestPackagesArry.filter((result) => {
    return result !== null && result !== undefined && result !== 'empty'
  })
  if (testPackagesRemoveNull.length > 0) {
    testInfoArray.testPackages = testPackagesRemoveNull
    testInfoArray.isTestPackageVariant = false;
  } else {
    testInfoArray.testPackages = testPackagesRemoveNull
    testInfoArray.isTestPackageVariant = true;
  }
  return testInfoArray
}
//To combine the all Individual test packages for same Product Type
export const individualPackageEqualProductTypeArry = (testInfoArray, field, payload, oldProductType, newProductType) => {
  if (field.indexOf('testPackagesJewelry') !== -1) {
    if (field.match(/\d/g) !== null) {
      if (field.match(/\d/g) && field.match(/\d/g).length === 1) {
        testInfoArray.testPackagesJewelryValidationArry[field.match(/\d/g)] = payload;
      } else {
        testInfoArray.testPackagesJewelryValidationArry[field.match(/\d\d/g)] = payload;
      }
    }
    if (payload === null) {
      testInfoArray.isMaterialVarient = false;
    }
  }
  else if (field.indexOf('testPackagesElectronic') !== -1) {
    if (field.match(/\d/g) !== null) {
      if (field.match(/\d/g) && field.match(/\d/g).length === 1) {
        testInfoArray.testPackagesElectronicValidationArry[field.match(/\d/g)] = payload;
      } else {
        testInfoArray.testPackagesElectronicValidationArry[field.match(/\d\d/g)] = payload;
      }
    }
  }
  else if (field.indexOf('testPackagesPackaging') !== -1) {
    if (field.match(/\d/g) !== null) {
      if (field.match(/\d/g) && field.match(/\d/g).length === 1) {
        testInfoArray.testPackagesPackagingValidationArry[field.match(/\d/g)] = payload;
      } else {
        testInfoArray.testPackagesPackagingValidationArry[field.match(/\d\d/g)] = payload;
      }
    } else if (field === 'testPackagesPackaging' && Array.isArray(payload)) {
      // When the full array is dispatched (e.g. change('testPackagesPackaging', newArray)),
      // sync the validation array so R&D + individual-test selection validates correctly.
      testInfoArray.testPackagesPackagingValidationArry = payload;
    }
  }
  else if (field.indexOf('testPackages') !== -1) {
    if (field.match(/\d/g) !== null) {
      if (field.match(/\d/g) && field.match(/\d/g).length === 1) {
        testInfoArray.testPackagesValidationArry[field.match(/\d/g)] = payload;
        
      } else {
        testInfoArray.testPackagesValidationArry[field.match(/\d\d/g)] = payload;
      }
    } else if (field === 'testPackages' && Array.isArray(payload)) {
      // When the full array is dispatched (e.g. change('testPackages', newArray)),
      // sync the validation array so R&D + individual-test selection validates correctly.
      testInfoArray.testPackagesValidationArry = payload;
    }
  }
  const selectedTestPackagesArry = testInfoArray.testPackagesValidationArry
  const selectedTestPackagesJeweleryArry = testInfoArray.testPackagesJewelryValidationArry
  const selectedTestPackagesPackagingArry = testInfoArray.testPackagesPackagingValidationArry
  const selectedTestPackagesElectronicArry = testInfoArray.testPackagesElectronicValidationArry
  const finalTestPackagesArry = union(selectedTestPackagesArry, selectedTestPackagesElectronicArry, selectedTestPackagesJeweleryArry, selectedTestPackagesPackagingArry)
  const testPackagesRemoveNull = finalTestPackagesArry.filter((result) => {
    return result !== null && result !== undefined && result !== 'empty'
  })
  if (testPackagesRemoveNull.length > 0) {
    testInfoArray.testPackages = testPackagesRemoveNull
    testInfoArray.isTestPackageVariant = false;
  } else {
    testInfoArray.testPackages = testPackagesRemoveNull
    testInfoArray.isTestPackageVariant = true;
  }
  // In Edit mode keep testPackagesForEdit in sync with the live selection.
  // testPackagesValidationArry is seeded at the correct form-checkbox indices during
  // testingInfoValidationsForEdit, so testPackagesRemoveNull (derived from that array)
  // accurately reflects what is currently checked — including after unchecking a package.
  // The old approach of always resetting testPackages to the stale testPackagesForEdit
  // snapshot prevented validation from detecting that all packages had been deselected.
  if (testInfoArray.testingInfoStatus === 'Edit') {
    testInfoArray.testPackagesForEdit = testPackagesRemoveNull;
    testInfoArray.testPackages = testPackagesRemoveNull;
    testInfoArray.isTestPackageVariant = testPackagesRemoveNull.length === 0;
  }
  testInfoArray.testPackage = (oldProductType !== newProductType && testInfoArray.selectedPackages === true) ? [] : payload
 /*  if (!(testInfoArray.testPackagesValidationArry
    .filter(element => element != null).length === 0)  && testInfoArray.testPackage !== null) {
    testInfoArray.isTestPackageVariant = find(
      union(
        individualTest[0].common,
        //individualTest[0].toys,
        individualTest[0].electronic,
        individualTest[0].packaging,
        individualTest[0].jewelry
      ),
      ['id', payload]
    ).variant;
  } */
 return testInfoArray
}

// Helper function to handle material type field changes
// const handleMaterialTypeFieldChange = (field, payload, testInfoArray) => {
//   if (field.match(/\d/g) !== null) {
//     // Extract material index/ID from field name
//     const materialIndex = field.match(/\d/g) && field.match(/\d/g).length === 1 
//       ? field.match(/\d/g)[0] 
//       : field.match(/\d\d/g) && field.match(/\d\d/g)[0];
    
//     if (materialIndex !== null) {
//       testInfoArray.materialNames[materialIndex] = payload;
//     }
    
//     // If material is being deselected (payload is null), clear its variant field
//     if (payload === null && materialIndex !== null) {
//       // Get the old material ID that was at this index to clear its variant
//       // We need to check all material IDs to find which variant field to clear
//       MaterialTypes.forEach(material => {
//         if (material.variant) {
//           // Clear this material's variant field if it exists
//           if (Object.prototype.hasOwnProperty.call(testInfoArray, `variants${material.id}`)) {
//             // Only clear if this material is no longer in materialNames
//             const isStillSelected = testInfoArray.materialNames.filter(v => v !== null).includes(material.id);
//             if (!isStillSelected) {
//               delete testInfoArray[`variants${material.id}`];
//               // If it's material 405, also clear subVariants
//               if (material.id === 405) {
//                 testInfoArray.subVariants = 0;
//               }
//             }
//           }
//         }
//       });
//     }
    
//     testInfoArray.materialName = payload;
//     const materialName = testInfoArray.materialNames.filter(value => value !== null);
    
//     // Check if any remaining materials have variants
//     let hasAnyMaterialWithVariant = false;
//     let allVariantsPresent = true;
    
//     for (let val of materialName) {
//       testInfoArray.materialName = val;
//       const materialConfig = find(MaterialTypes, ['id', val]);
//       if (materialConfig && materialConfig.variant) {
//         hasAnyMaterialWithVariant = true;
//         const hasVariantValue = Object.prototype.hasOwnProperty.call(testInfoArray, `variants${val}`) 
//           && testInfoArray[`variants${val}`] !== null 
//           && testInfoArray[`variants${val}`] !== undefined;
        
//         if (!hasVariantValue && !materialConfig.variantNotMandatory) {
//           allVariantsPresent = false;
//           break;
//         }
//       }
//     }
    
//     testInfoArray.isMaterialVarient = hasAnyMaterialWithVariant;
//     testInfoArray.allVarientPresent = allVariantsPresent;
    
//     if (materialName.includes(400)) {
//       testInfoArray.multiVariantMaterial = true;
//     } else {
//       testInfoArray.multiVariantMaterial = false;
//       testInfoArray.multiVariants = [];
//     }
//   } else {
//     if (field === 'materialType') {
//       testInfoArray.testPackagesValidationArry = testInfoArray.testPackagesValidationArry && testInfoArray.testPackagesValidationArry.length > 0 ? testInfoArray.testPackagesValidationArry : [null];
//       testInfoArray.testPackages = testInfoArray.testPackages && testInfoArray.testPackages.length > 0 ? testInfoArray.testPackages : [];
//     } else if (field === 'electCategory') {
//       testInfoArray.testPackagesElectronicValidationArry = [];
//       testInfoArray.testPackages = Array.isArray(testInfoArray.testPackages) && testInfoArray.testPackages.length > 0
//         ? testInfoArray.testPackages.filter(v => ![555, 556].includes(v))
//         : [];
//       testInfoArray.testPackage = Array.isArray(testInfoArray.testPackage) && testInfoArray.testPackage.length > 0
//         ? testInfoArray.testPackage.filter(v => ![555, 556].includes(v))
//         : [];
//     }
//   }
  
//   if (payload === null) {
//     const remainingMaterials = testInfoArray.materialNames.filter(value => value !== null);
//     testInfoArray.isMaterialVarient = remainingMaterials.some(materialId => {
//       const materialConfig = find(MaterialTypes, ['id', materialId]);
//       return materialConfig && materialConfig.variant;
//     });
//   }
// };

// // Helper function to handle material variants field changes
// const handleMaterialVariantsFieldChange = (field, payload, testInfoArray) => {
//   if (payload !== null) {
//     testInfoArray.variants = true;
//     testInfoArray[`variants${filter(MaterialTypes, { variants: [{ id: payload }] })[0].id}`] = payload;
//   }
  
//   if (field.indexOf(`variants400`) !== -1) {
//     if (payload !== null) {
//       testInfoArray.multiVariants.push(payload);
//     } else {
//       testInfoArray.multiVariants.pop();
//     }
//   }
  
//   // REMOVED: Don't clear all variants when one is set to null
//   // This was causing validation issues when checking/unchecking materials
//   // Individual variant cleanup is handled by materialType field changes

//   const materialName = testInfoArray.materialNames.filter(value => value !== null);
  
//   // Check if all selected materials with variants have their variants selected
//   let allVariantsPresent = true;
//   for (let val of materialName) {
//     testInfoArray.materialName = val;
//     const materialConfig = find(MaterialTypes, ['id', val]);
//     if (materialConfig && materialConfig.variant) {
//       const hasVariantValue = Object.prototype.hasOwnProperty.call(testInfoArray, `variants${val}`) 
//         && testInfoArray[`variants${val}`] !== null 
//         && testInfoArray[`variants${val}`] !== undefined;
      
//       if (hasVariantValue || materialConfig.variantNotMandatory) {
//         // This material has its variant or variant is not mandatory
//         continue;
//       } else {
//         // This material needs a variant but doesn't have one
//         allVariantsPresent = false;
//         break;
//       }
//     }
//   }
//   testInfoArray.allVarientPresent = allVariantsPresent;
// };

// //PFAS Logibc for 597 and 586 test packages when reppelent and food/mouth toggles are changed
// const handlePFASValidation = (testInfoArray) => {
//   const ensureArray = a => Array.isArray(a) ? a : [];

//   testInfoArray.testPackagesValidationArry = ensureArray(testInfoArray.testPackagesValidationArry);
//   testInfoArray.testPackagesPackagingValidationArry = ensureArray(testInfoArray.testPackagesPackagingValidationArry);
//   testInfoArray.testPackagesJewelryValidationArry = ensureArray(testInfoArray.testPackagesJewelryValidationArry);
//   testInfoArray.testPackagesElectronicValidationArry = ensureArray(testInfoArray.testPackagesElectronicValidationArry);
//   testInfoArray.testPackages = ensureArray(testInfoArray.testPackages);

//   const rebuildPackages = () => {
//     const combined = union(
//       testInfoArray.testPackagesValidationArry,
//       testInfoArray.testPackagesElectronicValidationArry,
//       testInfoArray.testPackagesJewelryValidationArry,
//       testInfoArray.testPackagesPackagingValidationArry
//     ).filter(v => v !== null && v !== undefined && v !== 'empty');
//     testInfoArray.testPackages = combined;
//   };

//   const isPackaging =
//     testInfoArray.currentProductType === 206 ||
//     testInfoArray.InitialProductType === 206 ||
//     testInfoArray.currentProductId === 206 ||
//     testInfoArray.productIdEdit === 206;

//   // Should add 597 if either Repellent or Food/Mouth is Yes (skip add in Edit mode)
//   const shouldAdd597 = (testInfoArray.repellent === true || testInfoArray.foodOrMouth === true);

//   if (shouldAdd597 && !testInfoArray.testPackagesValidationArry.includes(597)) {
//     // place at known slot (8) as used elsewhere
//     testInfoArray.testPackagesValidationArry[8] = 597;
//   }

//   // Add 586 only when Repellent = Yes and product is Packaging (skip add in Edit mode)
//   if (testInfoArray.repellent === true) {
//     if (isPackaging && !testInfoArray.testPackagesPackagingValidationArry.includes(586)) {
//       testInfoArray.testPackagesPackagingValidationArry[5] = 586;
//     }
//   }

//   if (testInfoArray.repellent === false && testInfoArray.foodOrMouth === false) {
//     if (Array.isArray(testInfoArray.testPackagesValidationArry)) {
//       testInfoArray.testPackagesValidationArry[8] = null;
//     }
//     if (Array.isArray(testInfoArray.testPackages)) {
//       testInfoArray.testPackages = testInfoArray.testPackages.filter(item => item !== 597);
//     }
//   }
//   if (testInfoArray.repellent === false) {
//     if (Array.isArray(testInfoArray.testPackagesPackagingValidationArry)) {
//       testInfoArray.testPackagesPackagingValidationArry[5] = null;
//     }
//     if (Array.isArray(testInfoArray.testPackages)) {
//       testInfoArray.testPackages = testInfoArray.testPackages.filter(item => item !== 586);
//     }
//   }

//   rebuildPackages();
//   return testInfoArray;
// };

export const testingInfoValidations = (field, payload, type, oldProductType, newProductType, editProductId, getProductTypeChangeStatus) => {
  const testPackagesElectronicNullArry = new Array(individualTest[0].electronic.filter(data => data.isTestAvailable === true).length).fill(null);
  testInfoArray = testingInformationArry(field, payload, oldProductType, newProductType, getProductTypeChangeStatus)
  testInfoArray.InitialProductType = oldProductType;
  testInfoArray.currentProductType = newProductType;
  testInfoArray.productIdEdit = editProductId !== '' ? editProductId : ''
  //testInfoArray.materialNames = testInfoArray.materialType && testInfoArray.materialType.length > 0 ? testInfoArray.materialType : []
  testInfoArray.testPackagesElectronicValidationArry = 
  (testInfoArray.electCategory === "" && testInfoArray.productIdEdit === 204) ?  testPackagesElectronicNullArry : testInfoArray.testPackagesElectronicValidationArry

  if (field.indexOf('subVariants') === 0) {
    testInfoArray.subVariants = payload;
  }
  if (field.indexOf('materialType') !== -1) {
    if (field.match(/\d/g) !== null) {
      if (field.match(/\d/g) && field.match(/\d/g).length === 1) {
        testInfoArray.materialNames[field.match(/\d/g)] = payload;
      } else {
        testInfoArray.materialNames[field.match(/\d\d/g)] = payload;
      }
      // Keep materialType in sync so the Edit-mode snapshot (lines below) never
      // overwrites materialNames with stale initial data when a checkbox changes.
      if (Array.isArray(testInfoArray.materialType)) {
        if (field.match(/\d/g) && field.match(/\d/g).length === 1) {
          testInfoArray.materialType[field.match(/\d/g)] = payload;
        } else {
          testInfoArray.materialType[field.match(/\d\d/g)] = payload;
        }
      }
      testInfoArray.materialName = payload;
      const materialName = testInfoArray.materialNames.filter(value => value !== null)
      for (let val of materialName) {
        testInfoArray.materialName = val;
        if (find(MaterialTypes, ['id', val]).variant) {
          testInfoArray.isMaterialVarient = true;
          if ((Object.prototype.hasOwnProperty.call(testInfoArray, `variants${val}` && `variants${val}` !== null))) {
            testInfoArray.allVarientPresent = true;
          } else {
            if (payload && find(MaterialTypes, ['id', payload]).variant) {
              if (payload === 400 ? testInfoArray.multiVariants.filter(v => v != null).length > 0 : testInfoArray[`variants${payload}`]) {
                testInfoArray.allVarientPresent = true;
              }
              else if (find(MaterialTypes, ['id', payload]).variantNotMandatory || (payload === 6017 && testInfoArray.enableTP2 !== true)) {
                testInfoArray.allVarientPresent = true;
              }
              else {
                testInfoArray.allVarientPresent = false;
              }
            }
            break
          }
        }
      }
      testInfoArray.multiVariantMaterial = materialName.includes(400);
      if (!materialName.includes(400)) { testInfoArray.multiVariants = []; testInfoArray.variants400 = null; }
    } else {
       testInfoArray.testPackagesValidationArry =  [null]
       // When the entire materialType array is replaced (e.g. on product type change),
       // sync the module-level materialType so materialNames is not populated with stale IDs.
       if (Array.isArray(payload)) resetMaterialTypeArray(payload);
    }
    if (payload === null) {
      testInfoArray.isMaterialVarient = false;
    }
  }
  if (field.indexOf(`variants`) !== -1 && field.startsWith("variants")) {
    if (payload !== null) {
      testInfoArray.variants = true;
      testInfoArray[`variants${filter(MaterialTypes, { variants: [{ id: payload }] })[0].id}`] = payload;
    }
    if (field.indexOf(`variants400`) !== -1) {
      Object.assign(testInfoArray, {multiVariants: (testInfoArray.multiVariants[+(field.match(/\[(\d+)\]/)?.[1] ?? '0')] = payload, testInfoArray.multiVariants), variants400: testInfoArray.multiVariants.find(v => v != null) ?? null});
    }
    if (payload === null) {
      testInfoArray[field] = null;
    }

    const materialName = testInfoArray.materialNames.filter(value => value !== null)
    for (let val of materialName) {
      testInfoArray.materialName = val;
      if (find(MaterialTypes, ['id', val]).variant) {
        if (val === 400 ? testInfoArray.multiVariants.filter(v => v != null).length > 0 : (Object.prototype.hasOwnProperty.call(testInfoArray, `variants${val}`) && testInfoArray[`variants${val}`] != null)) {
          testInfoArray.allVarientPresent = true;
        }
        else if (find(MaterialTypes, ['id', val]).variantNotMandatory || (val === 6017 && testInfoArray.enableTP2 !== true)) {
          testInfoArray.allVarientPresent = true;
        }
        else {
          testInfoArray.allVarientPresent = false;
          break
        }
      }
    }

  }
  //Logic for to reset the Individual test packages based on Product Type
  // Guard with getProductTypeChangeStatus so that once the product-type change is
  // acknowledged (flag set back to false) subsequent selections — including PFAS
  // auto-add — go through the normal equal-product-type path.
  if (field.indexOf('testPackages') !== -1 && (oldProductType !== newProductType) && getProductTypeChangeStatus === true) {
    testInfoArray.selectedPackages = true
    const finalIndividualTestPackages = individualPackageNotEqualProductTypeArry(testInfoArray, field, payload, oldProductType, newProductType)
    testInfoArray = finalIndividualTestPackages
    testInfoArray.testPackage = payload !== null ? payload : '';
  }
  //Logic for without changing the Product Type/ Equal Product Type
  else if (field.indexOf('testPackages') !== -1) {
    const finalIndividualPackages = individualPackageEqualProductTypeArry(testInfoArray, field, payload, oldProductType, newProductType)
    testInfoArray = finalIndividualPackages
  }
  else if(field.indexOf('testPackages') === -1){
    testInfoArray.isTestPackageVariant = false;
  }
  if (field.indexOf(`tp-variants${testInfoArray.testPackage}`) === 0) {
    testInfoArray.tp_variants = true;
    testInfoArray[`tp-variants${testInfoArray.testPackage}`] = payload;
    testInfoArray.testPackageVariants.push(payload);
  }
  else if (field.indexOf(`tp-variants${testInfoArray.testPackage}`) !== -1) {
    testInfoArray.tp_variants = true;
    testInfoArray[`tp-variants${testInfoArray.testPackage}`] = payload;
    testInfoArray.testPackageVariants.push(payload);
  }
  //Logic for PFAS(597) Common Validation Check
  if(testInfoArray.testingInfoStatus !== 'Edit' &&  testInfoArray.testPackage &&
    testInfoArray.testPackage.length > 0 && testInfoArray.testPackage.filter(ele => ele !== null).includes(597) === true){
      if(testInfoArray.testPackagesValidationArry.includes(597) === false){
        testInfoArray.testPackagesValidationArry[8] = 597
      }
  }
  //Logic for PFAS(586) Packaging Validation Check
  if(testInfoArray.testingInfoStatus !== 'Edit' &&  testInfoArray.testPackage &&
    testInfoArray.testPackage.length > 0 && testInfoArray.testPackage.filter(ele => ele !== null).includes(586) === true){
      if(testInfoArray.testPackagesPackagingValidationArry.includes(586) === false){
        testInfoArray.testPackagesPackagingValidationArry[5] = 586
      }
  }
  //Initial load of new created TRF(Not second load if TRF) failing because of materialNames is assign to null
 if (
    testInfoArray.testingInfoStatus !== 'Edit' &&
    Array.isArray(testInfoArray.materialType)
    ) {
    if (testInfoArray.materialType.filter(v => v !== null).length > 0) {
      testInfoArray.materialNames = testInfoArray.materialType;
    } else {
      testInfoArray.materialNames = [];
    }
    } else if (
    testInfoArray.testingInfoStatus === 'Edit' &&
    Array.isArray(testInfoArray.materialType)
    ) {
    if (testInfoArray.materialType.filter(v => v !== null).length > 0) {
      testInfoArray.materialNames = testInfoArray.materialType;
    } else {
      // All material type checkboxes have been unchecked in Edit mode.
      // Clear materialNames so validation correctly detects no materials are selected.
      testInfoArray.materialNames = [];
    }
    }   
    return testInfoArray
};

//Edit form to append the form values here
export const testingInfoValidationsForEdit = (field, payload, editProductId) => {
  testInfoArray.season = payload.season ? true : false;
  testInfoArray.testingType = payload.testingType ? payload.testingType : '';
  testInfoArray.isMaterial = payload.materialName ? payload.materialName : '';
  testInfoArray.pColor = payload.pigmentColor ? payload.pigmentColor : '';
  testInfoArray.testPackage = payload.testPackage ? payload.testPackage : '';
  testInfoArray.sampleDescription = payload.sampleDescription ? payload.sampleDescription : '';
  testInfoArray.sampleType = payload.sampleType ? payload.sampleType : '';
  testInfoArray.ageGroup = payload.ageGroup ? payload.ageGroup : '';
  testInfoArray.sampleColor = payload.sampleColor ? payload.sampleColor : '';
  testInfoArray.skinContact = (payload.skinContact === 'Yes' || payload === 'Yes') ? true : false;
  /* testInfoArray.subRecycledContent = (payload.subRecycledContent === 'Post Consumer' ||
    payload.subRecycledContent === 'Post-Industrial') ? 'Yes' : 'No';
  testInfoArray.recycledContent = payload.recycledContent ? payload.recycledContent : ''; */
  testInfoArray.repellent = (payload.repellent && payload === 'Yes') ? true : false;
  testInfoArray.foodOrMouth = (payload.foodOrMouth && payload === 'Yes') ? true : false;
  testInfoArray.mates = payload.mates === 'Yes';
  testInfoArray.materialType = payload.materialType;
  //testInfoArray.productIdEdit = payload.prevProductId === 204 || payload.prevProductId === 206  || payload.prevProductId === 205? payload.prevProductId : '';
  testInfoArray.productIdEdit = payload.prevProductId !== '' ? payload.prevProductId : '';
  testInfoArray.electCategory = payload.electCategory ? payload.electCategory : '';
  testInfoArray.subVariants = payload.subVariants ? payload.subVariants : '';
  testInfoArray.testingInfoStatus = payload.testingInfoStatus;
  testInfoArray.testPackages = payload.testPackages.length > 0 ? payload.testPackages : [];
  testInfoArray.testPackagesElectronicValidationArry =  payload.testPackagesElectronic; //testPackagesElectronicValidationArry for Electronic section in testPackages
  testInfoArray.testPackagesJewelryValidationArry = payload.testPackagesJewelry; // testPackagesJewelryValidationArry for Jewelry section in testPackages
  testInfoArray.jewelryMaterialTypeValidation = payload.jeweleryMaterialType ? payload.jeweleryMaterialType : '';
  
  testInfoArray.recycle = payload.recycle === 'Yes' ? true : false;
  testInfoArray.listRecycle = payload.listRecycle ? payload.listRecycle : '';
  testInfoArray.describeRecycle = payload.describeRecycle ? payload.describeRecycle : '';

  if (payload && payload[`variants${testInfoArray.materialType}`]) {
    testInfoArray.variants = true;
    testInfoArray[`variants${testInfoArray.materialType}`] = payload[`variants${testInfoArray.materialType}`];
  }
  if (payload.materialType) {
    if (payload.materialType.filter(value => value !== null).length) {
      testInfoArray.materialNames = payload.materialType;
    }
    testInfoArray.materialNames.filter(value => value !== null)
      .forEach((val, index) => {
        if (find(MaterialTypes, ['id', val]).variant) {
          testInfoArray.allVarientPresent = true;
          testInfoArray[`variants${val}`] = payload[`variants${val}`]
          if (val === 400) {
            testInfoArray.multiVariantMaterial = true;
            testInfoArray.multiVariants = payload[`variants${val}`].filter(value => value !== null);
          }
        }
      })
  }
  syncYogaMateSolventValidation(testInfoArray);

  if (payload.testPackages) {
  
    testInfoArray.testPackagesForEdit = testInfoArray.testPackages.length > 0 ? testInfoArray.testPackages : [];
    testInfoArray.testPackagesPackagingValidationArry  =  payload.testPackagesPackaging; //testPackagesPackagingValidationArry for packaging section in testPackages
    testInfoArray.testPackagesValidationArry = payload.testPackages; // testPackagesValidationArry for common section in testPackages
    testInfoArray.testPackages.filter(value => value !== null)
      .forEach((val, index) => {
        testInfoArray.testPackage = val;
        const testPackagesArr = payload.testPackages;
        if (!(testPackagesArr.filter(element => element != null).length === 0) && testInfoArray.testPackage !== null) {
          testInfoArray.isTestPackageVariant = find(
            union(
              individualTest[0].common,
              individualTest[0].toys,
              individualTest[0].electronic,
              individualTest[0].packaging,
              individualTest[0].jewelry
            ),
            ['id', testInfoArray.testPackage]
          ).variant;
        }
        if (payload === null) {
          testInfoArray.isTestPackageVariant = false;
        } else if (testInfoArray.testPackages.length > 0) {
          testInfoArray.isTestPackageVariant = false;
        }
        if (payload[`tp-variants${testInfoArray.testPackage}`]) {
          testInfoArray.tp_variants = true;
          testInfoArray[`tp-variants${testInfoArray.testPackage}`] = payload[`tp-variants${testInfoArray.testPackage}`];
          testInfoArray.testPackageVariants.push(payload[`tp-variants${testInfoArray.testPackage}`]);
        }
      });
  }
  syncYogaMateSolventValidation(testInfoArray);
  return testInfoArray;
};

export const labLocationValidations = (field, payload, mode) => {
  if (field.indexOf('lab') !== -1) {
    labSelectionArray.locationPayload = payload;
    labSelectionArray[`labLocation${labSelectionArray.locationPayload}`] = null;
  }
  if (field.indexOf(`location${labSelectionArray.locationPayload}`) !== -1) {
    labSelectionArray[`labLocation${labSelectionArray.locationPayload}`] = payload;
  }
  return labSelectionArray;
};

export const labLocationValidationsForEdit = (field, payload) => {
  labSelectionArray.locationPayload = payload.lab ? payload.lab : '';
  labSelectionArray[`labLocation${labSelectionArray.locationPayload}`] = payload.labLocation;
  return labSelectionArray;
}

export const clearTestingInfo = () => {
 brandArray = {
    brandId: false,
    productId: false,
    isMaterial: '',
    isMaterialNumber: '',
    isError: true,
    isRetest:false,
    originalTRF:''
  };
  testInfoArray = {
    season: false,
    variants: false,
    testingType: 'PR',
    isMaterialTypeVariant: true,
    isMaterialType: false,
    materialType: '',
    materialNames: [],
    multiVariantMaterial: false,
    multiVariants: [],
    isMaterialVarient: false,
    allVarientPresent: false,
    pColor: '',
    sampleDescription: '',
    repellent: false,
    foodOrMouth: false,
    mates: false,
    isTestingType: false,
    testPackages: [],
    testPackage: '',
    testPackageVariants: [],
    isTestPackageVariant: false,
    initialProductId: 0,
    currentProductId: 0,
    isError: true,
    recycle:false,
    listRecycle:'',
    describeRecycle:'',
    //subRecycledContent: 'No',
    //recycledContent: 'No',
    currentProductType: 100,
    InitialProductType: 100,
    selectedPackages: false,
    testPackagesValidationArry: [],
    testPackagesJewelryValidationArry: [],
    testPackagesElectronicValidationArry: [],
    testPackagesPackagingValidationArry: [],
    jewelryMaterialTypeValidation:' ',
    testPackagesForEdit: [],
    subVariants: 0,
    skinContact: false,
    electCategory: '',
    productIdEdit: 1,
    sampleType:'',
    ageGroup:'',
    sampleColor:''
  };
  labSelectionArray = {
    islabSelect: false,
    locationPayload: '',
    labLocation: false,
    isServiceRequest: false,
    isError: true
  };
};
